"use strict";

const initFlowbox = () => {
    const flowboxElem =  document.getElementById("js-flowbox-flow");
    const flowboxCommunityElement =  document.getElementById("flowbox-community");
    const flowboxCheckoutKey = document.getElementById("flowboxCheckoutKey");
    const flowboxProductElement = document.getElementById("flowbox-product");

    if ((typeof(flowboxElem) != "undefined" && flowboxElem != null) || (typeof(flowboxCheckoutKey) != "undefined" && flowboxCheckoutKey != null)) {
        (function (d, id) {
            if (!window.flowbox) { var f = function () { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
            if (d.getElementById(id)) {return;}
            var s = d.createElement("script"), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
            s.src = " https://connect.getflowbox.com/flowbox.js";
            document.getElementsByTagName("head")[0].appendChild(s, fjs);
        })(document, "flowbox-js-embed");

        if (typeof(flowboxCheckoutKey) != "undefined" && flowboxCheckoutKey != null) {
            !function (e, t) {
                var o = document.createElement("script");
                o.type = "text/javascript", o.async = true, o.readyState ? o.onreadystatechange = function () {
                    (o.readyState === "loaded" || o.readyState === "complete") && (o.onreadystatechange = null, t());
                } : o.onload = function () {
                    t();
                }, o.src = e, document.getElementsByTagName("head")[0].appendChild(o);
            }("//connect.getflowbox.com/bzfy-checkout.js", function () {
                let arrayItems = [];
                let products = JSON.parse(document.querySelector("#flowboxCheckoutItems").getAttribute("value"));

                products.forEach(function (item) {
                    arrayItems.push({
                        id: item.masterID,
                        quantity: item.quantity
                    });
                });
                window.flowboxCheckout.checkout({
                    apiKey: document.querySelector("#flowboxCheckoutKey").getAttribute("value"),
                    products: arrayItems,
                    orderId: document.querySelector("#orderNumber").getAttribute("value")
                });
            });
        } else {
            const flowboxContainer = "#js-flowbox-flow";
            const flowboxKey = document.querySelector("#flowboxKey").getAttribute("value");
            const flowboxLocale = document.querySelector("#currentLocaleLanguage").getAttribute("value").replace("_", "-");

            if (typeof(flowboxProductElement) != "undefined" && flowboxProductElement != null) {
                window.flowbox("init", {
                    container: flowboxContainer,
                    key: flowboxKey,
                    locale: flowboxLocale,
                    productId: flowboxProductElement.getAttribute("data-product-id")
                });
            } else {
                window.flowbox("init", {
                    container: flowboxContainer,
                    key: flowboxKey,
                    locale: flowboxLocale
                });
            }

            if (typeof(flowboxCommunityElement) != "undefined" && flowboxCommunityElement != null) {
                const buttons = document.querySelectorAll(".flowbox-button[data-tag]");

                for (const button of buttons) {
                    button.addEventListener("click", () => {
                        window.flowbox("update", {
                            key: document.querySelector("#flowboxKey").getAttribute("value"),
                            tags: [button.dataset.tag]
                        });

                        for (const button of buttons) {
                            button.classList.remove("selected");
                        }

                        button.classList.add("selected");
                    });
                }
            }
        }
    }
};

module.exports = {
    initFlowbox: initFlowbox
};
